// If there are four or more capital letters in a row, return true on test
export const capitalsRegex = /[A-Z]{4,}/;
